export const loadGoogleSdk = () => {
    (() => {
        const element = document.getElementsByTagName('script')[0];
        const sdk = document.createElement('script');
        sdk.src = `https://apis.google.com/js/platform.js?onload=init`;
        element?.parentNode?.insertBefore(sdk, element);
    })();
};
